import React from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { OpenPaperIcon } from "./style/styledComponents";
import { ReactComponent as PaperIcon } from "../../assets/imgs/icons/open_paper.svg";
import { ArticlePaperContent } from "./ArticlePaperContent";
import { useTheme } from "@material-ui/core";

export const ArticlePaper = ({
  article,
  onHide,
  isArticlePaperOpen,
  setOpenArticlePaper,
  deleteSnippet,
  saveArticle,
  saveSnippet,
  frameSource,
  status,
  error,
  activeTab,
  setActiveTab,
  openTagModal,
}) => {
  const theme = useTheme();

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={isArticlePaperOpen}
        addEndListener={(node, done) =>
          node.addEventListener("transitionend", done, false)
        }
        classNames="fade"
      >
        {isArticlePaperOpen ? (
          <ArticlePaperContent
            onHide={onHide}
            article={article}
            deleteSnippet={deleteSnippet}
            saveArticle={saveArticle}
            saveSnippet={saveSnippet}
            frameSource={frameSource}
            status={status}
            error={error}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            openTagModal={openTagModal}
          />
        ) : (
          <OpenPaperIcon
            onClick={() => setOpenArticlePaper(true)}
            theme={theme}
          >
            {/* <i className="fa fa-file-text-o" aria-hidden="true" size={30} /> */}
            <PaperIcon />
          </OpenPaperIcon>
        )}
      </CSSTransition>
    </SwitchTransition>
  );
};
